export default "__VITE_ASSET__qqdWhR1k__"